import script from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppButtonIcon.vue?vue&type=style&index=0&id=47478d5f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47478d5f"]])

export default __exports__